import { useEffect, useState } from "react";
import styled from "styled-components";
import AboutService from "../../API/AboutService";
import SocialIcons from "../SocialIcons";


const FooterBlackBackground = styled.div`
    width: 100%;
    max-width: 1920px;
    margin-left: auto;
    margin-right: auto;
    background-color: #1b1b1b;
    min-height: 230px;
    padding: 40px 20px;
`

const FooterBlackWrapper = styled.div`
    width: 100%;
    max-width: 1240px;
    margin-left: auto;
    margin-right: auto;    


    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    
    @media(max-width:920px) {
        justify-content: center;
    }       
`

const FooterBlackLogo  = styled.img`
    align-self: flex-start;
    margin-right: 30px;
    margin-bottom: 30px;
`

const FooterBlackAddress  = styled.div`
    align-self: flex-start;
    color: #ebebeb;
    font-size: 0.95rem;
    font-weight: 400;
    margin-right: 20px;
`

const FooterBlackAddressItem  = styled.div`    
    display: flex;
    flex-wrap: nowrap;
    margin-bottom: 40px;

    img {
        align-self: center;
        margin-right: 20px;
    }
`

const FooterBlackSocialLinks  = styled.div`
    align-self: flex-start;
    min-width: 200px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    margin-bottom: 20px;

    img {
        transition: .3s ease-in-out;
        margin-right: 15px;        
    }
    img:hover {
        transform: scale(1.20);
    }
`

const FooterBlackCopyright  = styled.div`
    padding-left: 80px;
    color: #ebebeb;
    font-size: 0.95rem;

    @media(max-width:920px) {
        /* text-align: center; */
        padding-top: 20px;
        padding-left: 0;
    }     
`

const FooterBlack = () => {
    // Адреса офисов редактируются в админке (раздел "Тексты About", инлайн "Офисы")
    const [offices, setOffices] = useState([]);

    useEffect(() => {
        AboutService.getAbout()
            .then(response => setOffices(response.data.offices))
            .catch(error => console.log('Не удалось загрузить офисы для подвала: ' + error));
    }, []);

    return (
        <FooterBlackBackground>
            <FooterBlackWrapper>
                <FooterBlackLogo src="/images/footer_logo.png" />
                <FooterBlackAddress>
                    {offices.map((office, index) => (
                        <FooterBlackAddressItem key={index}>
                            <img src="/images/footer_location_icon.png" />
                            <p>
                                {office.address} <br/>
                                {office.phone}
                            </p>
                        </FooterBlackAddressItem>
                    ))}
                </FooterBlackAddress>
                <FooterBlackSocialLinks>
                    <SocialIcons />
                </FooterBlackSocialLinks>
            </FooterBlackWrapper>
            <FooterBlackCopyright>
                &copy; Magic Frame Animation, {new Date().getFullYear()}
            </FooterBlackCopyright>
        </FooterBlackBackground>
     );
}
 
export default FooterBlack;